import service from '../../services/markrunasprocessed';
import SubmissionError from "../../error/SubmissionError";

const handleError = (commit, e) => {
  commit(ACTIONS.TOGGLE_LOADING);

  if (e instanceof SubmissionError) {
    commit(ACTIONS.SET_VIOLATIONS, e.errors);
    // eslint-disable-next-line
    commit(ACTIONS.SET_ERROR, e.errors._error);

    return;
  }

  // eslint-disable-next-line
  commit(ACTIONS.SET_ERROR, e.message);
};

const ACTIONS = {
  SET_ITEM: 'SET_ITEM',
  TOGGLE_LOADING: 'TOGGLE_LOADING',
  SET_VIOLATIONS: 'SET_VIOLATIONS',
  SET_ERROR: 'SET_ERROR',
};


export default {
  namespaced: true,
  state: {
    item: null,
    isLoading: false
  },
  actions: {
    process: ({ commit }, { paymentRun }) => {
      commit(ACTIONS.TOGGLE_LOADING);

      return service.create({ paymentRun })
        .then(response => response.json())
        .then(data => {
          commit(ACTIONS.TOGGLE_LOADING);
          commit(ACTIONS.SET_ITEM, data);
        })
        .catch(e => handleError(commit, e));
    }
  },
  mutations: {
    [ACTIONS.SET_ITEM]: (state, item) => {
      Object.assign(state, { item })
    },
    [ACTIONS.TOGGLE_LOADING]: (state) => {
      Object.assign(state, { isLoading:  ! state.isLoading })
    }
  },
  getters: {
    item(state) {
      return state.item;
    },
    isLoading(state) {
      return state.isLoading;
    }
  }
}
